import { useRouter } from 'next/router';
import React, { useEffect } from 'react';
import GearExpertsLink from '~/components/Links/GearExpertsLink';
import { useConfigurationProperty } from '~/contexts/ConfigurationContext';
import { fireVisitedGearExperts } from '~/services/analytics/events/gearExperts';
import isGearExpertsOnlineScheduled from '~/utils/isGearExpertsOnlineScheduled';
import {
  FT_GEAR_EXPERTS_BANNER,
  FT_GEAR_EXPERTS_USE_SCHEDULE,
} from '../../../constants/featureToggles';

interface Props {}

const GearExpertsPersistentSearchBanner: React.FC<Props> = () => {
  const router = useRouter();
  const gearExpertsEnabled = useConfigurationProperty('gear_experts');

  let shouldSeeBanner = false;

  if (gearExpertsEnabled && /\/(hockey|golf|baseball)/i.test(router.asPath)) {
    if (FT_GEAR_EXPERTS_BANNER) {
      shouldSeeBanner = true;
      if (FT_GEAR_EXPERTS_USE_SCHEDULE) {
        shouldSeeBanner = isGearExpertsOnlineScheduled();
      }
    }
  }

  useEffect(() => {
    if (shouldSeeBanner) {
      fireVisitedGearExperts('banner');
    }
  }, []);

  if (!shouldSeeBanner) {
    return null;
  }

  return (
    <div
      className="mb-4 py-4 text-center md:flex md:justify-center md:space-x-2"
      css={`
        background-color: #d0dcd6;
      `}
    >
      <div className="mb-2 font-semibold md:mb-0">
        Need help finding the perfect gear for you?
      </div>

      <GearExpertsLink className="underline" src="banner">
        Chat with a Gear Expert
      </GearExpertsLink>
    </div>
  );
};

export default GearExpertsPersistentSearchBanner;
